export default __webpack_public_path__ + "static/media/erro.0eb7921b.png";